export const provideStripeKey = (environment) => {
  if (environment === "development") {
    return "pk_test_51JSYSPL5faruNVO2Yb2oX6ffHvYdkuyBs28H9RwIoBD8uiVKsxZKY9g6L6fREOYN5oDAwkDAVC0LfMGnbDUUkJq300uZDcwwA6";
  } else {
    return "pk_live_51JSYSPL5faruNVO2F2u8m4kV9pTeUfBVwoBCRjz2UApSkmm5X1PshF709q7ir7VdJIjYhGnrGDBoITzdrE8zKg8S00dVNULkYP";
  }
};
